import { BrandIllustration } from "@/components/brand/BrandIllustration";
import { useTranslation } from "react-i18next";
import { BriefcaseBusiness, Building2, House } from "lucide-react";
import { AnimatedSection } from "@/components/home/AnimatedSection";

const locationItems = [
  { key: "home", icon: House },
  { key: "hotel", icon: Building2 },
  { key: "other", icon: BriefcaseBusiness },
] as const;

export const VisitLocations = () => {
  const { t } = useTranslation("doctorVisits");

  return (
    <section id="visit-locations" tabIndex={-1} className="px-4 py-20 sm:px-6 sm:py-24 lg:px-8">
      <AnimatedSection className="mx-auto max-w-[1168px]">
        <div className="grid gap-12 lg:grid-cols-[0.72fr_1.28fr] lg:gap-20">
          <div>
            <p className="text-sm font-semibold uppercase tracking-[0.16em] text-primary">
              {t("locations.eyebrow")}
            </p>
            <h2 className="mt-4 text-3xl font-bold tracking-tight text-foreground sm:text-4xl">
              {t("locations.title")}
            </h2>
            <p className="mt-5 max-w-md text-lg leading-8 text-muted-foreground">
              {t("locations.description")}
            </p>
            <BrandIllustration scene="workplace" className="mt-7" />
          </div>

          <div className="divide-y divide-border border-y border-border">
            {locationItems.map(({ key, icon: Icon }) => (
              <div
                key={key}
                className="grid gap-4 py-7 sm:grid-cols-[3rem_0.7fr_1.3fr] sm:items-start sm:gap-6 sm:py-8"
              >
                <span className="flex h-11 w-11 items-center justify-center rounded-full bg-accent text-primary">
                  <Icon className="h-5 w-5" aria-hidden="true" />
                </span>
                <h3 className="text-lg font-semibold leading-7 text-foreground">
                  {t(`locations.items.${key}.title`)}
                </h3>
                <p className="leading-7 text-muted-foreground">
                  {t(`locations.items.${key}.description`)}
                </p>
              </div>
            ))}
          </div>
        </div>
      </AnimatedSection>
    </section>
  );
};
